module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module chunks = 1